import BaseService from '../BaseService';

class PackageService extends BaseService {
  listPackages = async () => {
    return this._api.post('/package/list', {});
  };

  getCurrent = async () => {
    return this._api.post('/package/current', {});
  };

  createUpgradeRequest = async ({ package_key, duration_months }) => {
    return this._api.post('/package/upgrade-request', { package_key, duration_months });
  };

  confirmPayment = async ({ request_id, payment_note }) => {
    return this._api.post('/package/upgrade-request/confirm-payment', { request_id, payment_note });
  };
}

export default PackageService;
